export default "__VITE_ASSET__SVCwWfY7__"